import { ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";
import { adsEnabled, AD_PROVIDER, setSupporter } from "../lib/entitlements.ts";
import { useApp } from "../state/store.ts";

/**
 * Right-hand ad rail (wide windows only — see styles.css). For now a neutral placeholder;
 * a real provider (AdSense, EthicalAds, Carbon…) plugs in here once consent + privacy page exist.
 */
export function AdRail() {
  const supporter = useApp((s) => s.supporter);
  const [collapsed, setCollapsed] = useState(false);
  const [about, setAbout] = useState(false);
  if (!adsEnabled(supporter)) return null;
  if (collapsed) return <button className="ad-tab" onClick={() => setCollapsed(false)} title="Show the ad space again">Ad<ChevronLeft className="trail" size={14} aria-hidden="true" /></button>;
  return (
    <aside className="ad-rail" aria-label="Advertisement">
      <div className="row between"><span className="ad-label">Advertisement</span><button className="ghost tiny" onClick={() => setCollapsed(true)} title="Collapse" aria-label="Collapse"><ChevronRight size={14} aria-hidden="true" /></button></div>
      {AD_PROVIDER === "placeholder" && (
        <div className="ad-box" style={{ width: 160, height: 600 }}>
          <span className="ad-dim">160 × 600</span>
          <b>Ad space</b>
          <span className="muted tiny">This keeps MC Planner free.</span>
        </div>
      )}
      <button className="link tiny" onClick={() => setAbout(true)}>Remove ads</button>
      {about && (
        <div className="modal-back" onClick={() => setAbout(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Support MC Planner</h3>
            <p className="small">Supporters won't see ads and will get extras (more shared worlds, bigger pinboards, …). This isn't available yet — it's coming.</p>
            <p className="muted tiny">The desktop app never shows ads.</p>
            <div className="choice">
              <button className="ghost" onClick={() => setAbout(false)}>OK</button>
              <button className="link tiny" onClick={() => { setSupporter(true); useApp.getState().set({ supporter: true }); setAbout(false); }}>I'm testing — hide ads on this device</button>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}
